// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2W5b0","title":"FrontImage_title__1NqnR"};